<script setup lang="ts">
import { computed } from 'vue'
import { riskConfig } from '../riskConfig'
import LegendText from './LegendText.vue'
import LegendGfx from './LegendGfx.vue'
import { parseRiskScore, scoreToLevel } from '../shared'

const props = defineProps<{
	class?: string
	isEdit?: boolean
}>()

const rows = computed(() =>
	Array(riskConfig.value.matrixSize)
		.fill(0)
		.map((_, index) => 1 + index)
		.reverse(),
)
const cols = computed(() => riskConfig.value.matrixSize)

function bg(x: number, y: number) {
	const score = parseRiskScore(x * y)
	const lvl = scoreToLevel(score)
	return 'background-color: ' + lvl?.color
}
</script>

<template>
	<table v-if="riskConfig.riskLevels.length" :class="props.class">
		<tr v-if="riskConfig.riskImpacts.length" v-for="y in rows">
			<td>
				<div class="sq d-flex">
					<LegendGfx :value="y" :color="riskConfig.riskLevels[y - 1].color" type="vertical" />
				</div>
			</td>
			<td>
				<div class="sq d-flex">
					<LegendText type="vertical" :is-edit="props.isEdit" v-model="riskConfig.riskImpacts[y - 1]" />
				</div>
			</td>

			<td v-for="x in cols" class="cell" :style="bg(x, y)">
				<div class="square d-flex align-items-center">
					<span class="mx-auto text">{{ x * y }}</span>
				</div>
			</td>
		</tr>
		<tr>
			<td>
				<div class="sq d-flex">
					<LegendGfx type="impact" />
				</div>
			</td>
			<td>
				<div class="sq d-flex"></div>
			</td>
			<td v-if="riskConfig.riskProbabilities.length" v-for="x in cols">
				<div class="sq d-flex">
					<LegendText type="horizontal" :is-edit="props.isEdit" v-model="riskConfig.riskProbabilities[x - 1]" />
				</div>
			</td>
		</tr>
		<tr>
			<td>
				<div class="sq d-flex"></div>
			</td>
			<td>
				<div class="sq d-flex">
					<LegendGfx type="probability" />
				</div>
			</td>

			<td v-for="x in cols">
				<div class="sq d-flex">
					<LegendGfx :value="x" :color="riskConfig.riskLevels[x - 1].color" type="horizontal" />
				</div>
			</td>
		</tr>
	</table>
</template>

<style lang="sass" scoped>
table
  table-layout: fixed

table, tr, td
  border: 0
  margin: 0
  padding: 0

.sq
  aspect-ratio: 1.8
  min-width: 3rem

.square
  position: absolute
  inset: 0
  border: 2px solid white
  border-radius: 0.5rem
  overflow: hidden

.cell
  border-radius: 0.5rem
  overflow: hidden
  position: relative

.text
  color: white
  text-shadow: 1px 1px 1px black
  font-size: 3vw
</style>
